import {
  GET_CONTENTS,
  GET_CONTENTS_ERROR,
  GET_CONTENTS_SUCCESS,
  DELETE_BUDGET_CONTENT,
  DELETE_SUBBUDGET_CONTENT,
  DELETE_CONTENT,
  DELETE_CONTENT_SUCCESS,
  DELETE_CONTENT_ERROR,
  UPDATE_BUDGET_CONTENT,
  UPDATE_BUDGET_CONTENT_SUCCESS,
  UPDATE_SUBBUDGET_CONTENT,
  UPDATE_SUBBUDGET_CONTENT_SUCCESS,
  UPDATE_CONTENT,
  UPDATE_CONTENT_ERROR,
  UPDATE_CONTENT_SUCCESS,
  CREATE_CONTENT,
  CREATE_CONTENT_ERROR,
  CREATE_CONTENT_SUCCESS,
  CLEAR_CONTENT_TARGET_STATUS,
} from './constants'

export const getContents = ({ targetId, contentType }) => ({
  type: GET_CONTENTS,
  targetId,
  contentType,
})

export const getContentsError = ({ error, targetId, contentType }) => ({
  type: GET_CONTENTS_ERROR,
  error,
  targetId,
  contentType,
})

export const getContentsSuccess = ({ targetId, contentType, contents }) => ({
  type: GET_CONTENTS_SUCCESS,
  contents,
  targetId,
  contentType,
})

export const deleteBudgetContent = ({
  contentId,
  targetId,
  contentType,
  parentTargetId,
  companyCode,
}) => ({
  type: DELETE_BUDGET_CONTENT,
  contentId,
  targetId,
  contentType,
  parentTargetId,
  companyCode,
})

export const deleteSubBudgetContent = ({
  contentId,
  targetId,
  contentType,
  parentTargetId,
  companyCode,
}) => ({
  type: DELETE_SUBBUDGET_CONTENT,
  contentId,
  targetId,
  contentType,
  parentTargetId,
  companyCode,
})

export const deleteContent = ({
  contentId,
  targetId,
  contentType,
  parentTargetId,
}) => ({
  type: DELETE_CONTENT,
  contentId,
  targetId,
  contentType,
  parentTargetId,
})

export const deleteContentError = ({
  contentId,
  error,
  targetId,
  contentType,
  parentTargetId,
}) => ({
  type: DELETE_CONTENT_ERROR,
  contentId,
  error,
  targetId,
  contentType,
  parentTargetId,
})

export const deleteContentSuccess = ({
  contentId,
  targetId,
  contentType,
  parentTargetId,
}) => ({
  type: DELETE_CONTENT_SUCCESS,
  contentId,
  targetId,
  contentType,
  parentTargetId,
})

export const updateBudgetContent = ({
  contentId,
  data,
  contentType,
  targetId,
  companyCode,
}) => ({
  type: UPDATE_BUDGET_CONTENT,
  contentId,
  data,
  contentType,
  targetId,
  companyCode,
})

export const updateSubBudgetContent = ({
  contentId,
  data,
  contentType,
  targetId,
  companyCode,
}) => ({
  type: UPDATE_SUBBUDGET_CONTENT,
  contentId,
  data,
  contentType,
  targetId,
  companyCode,
})

export const updateBudgetContentSuccess = ({
  contentId,
  data,
  contentType,
  targetId,
  content,
}) => ({
  type: UPDATE_BUDGET_CONTENT_SUCCESS,
  contentId,
  data,
  contentType,
  targetId,
  content,
})

export const updateSubBudgetContentSuccess = ({
  contentId,
  data,
  contentType,
  targetId,
  content,
}) => ({
  type: UPDATE_SUBBUDGET_CONTENT_SUCCESS,
  contentId,
  data,
  contentType,
  targetId,
  content,
})

export const updateContent = ({ contentId, data, contentType, targetId }) => ({
  type: UPDATE_CONTENT,
  contentId,
  data,
  contentType,
  targetId,
})

export const updateContentError = ({
  contentId,
  contentType,
  error,
  targetId,
}) => ({
  type: UPDATE_CONTENT_ERROR,
  contentId,
  contentType,
  error,
  targetId,
})

export const updateContentSuccess = ({
  contentId,
  data,
  contentType,
  targetId,
  content,
}) => ({
  type: UPDATE_CONTENT_SUCCESS,
  contentId,
  contentType,
  targetId,
  data,
  content,
})

export const createContent = ({
  contentType,
  targetId,
  data,
  temporaryContentId,
  parentTargetId,
  dimensionValueIds,
}) => ({
  type: CREATE_CONTENT,
  contentType,
  targetId,
  data,
  temporaryContentId,
  parentTargetId,
  dimensionValueIds,
})

export const createContentError = ({
  contentType,
  error,
  targetId,
  temporaryContentId,
  parentTargetId,
}) => ({
  type: CREATE_CONTENT_ERROR,
  contentType,
  error,
  targetId,
  temporaryContentId,
  parentTargetId,
})

export const createContentSuccess = ({
  content,
  contentType,
  targetId,
  temporaryContentId,
  parentTargetId,
}) => ({
  type: CREATE_CONTENT_SUCCESS,
  content,
  contentType,
  targetId,
  temporaryContentId,
  parentTargetId,
})

export const clearContentTargetStatus = ({
  contentType,
  targetId,
  parentTargetId,
}) => ({
  type: CLEAR_CONTENT_TARGET_STATUS,
  contentType,
  targetId,
  parentTargetId,
})
